var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__main"},[_vm._v("NUXT Frontend App Health Check Works!")])
}
var staticRenderFns = []

export { render, staticRenderFns }